import actionTypes from '../actions/actionTypes';

const initialState = {
  loading: false,
  data: [],
  currentDraft: {},
};

const updateDraftItems = (state, draftId) =>
  draftId ? state.currentDraft.additionalAttributes.draftItems.filter((draft) => draft.id !== draftId) : [];

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_ASSOCIATE_DRAFT_MESSAGES_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_ASSOCIATE_DRAFT_MESSAGES_SUCCESS:
      return {
        loading: false,
        data: payload,
      };
    case actionTypes.DELETE_ASSOCIATE_DRAFT_MESSAGE:
      return {
        loading: false,
        data: state.data.filter(({ messageId }) => messageId !== payload.messageId),
      };

    case actionTypes.UPDATE_ASSOCIATE_DRAFT_MESSAGE:
      return {
        loading: false,
        data: state.data.map((draft) => (payload.messageId === draft.messageId ? payload : draft)),
      };

    case actionTypes.CREATE_ASSOCIATE_DRAFT_MESSAGE:
      return {
        loading: false,
        data: [...state.data, payload],
      };
    case actionTypes.ADD_CURRENT_DRAFT:
      return {
        ...state,
        currentDraft: payload,
      };
    case actionTypes.REMOVE_DRAFT_ITEMS:
      return {
        ...state,
        currentDraft: {
          ...state?.currentDraft,
          additionalAttributes: {
            ...state?.currentDraft?.additionalAttributes,
            draftItems: updateDraftItems(state, payload),
          },
        },
      };
    case actionTypes.ADD_DRAFT_ITEMS:
      return {
        ...state,
        currentDraft: {
          ...state?.currentDraft,
          additionalAttributes: {
            ...state?.currentDraft?.additionalAttributes,
            draftItems: state?.currentDraft?.additionalAttributes?.draftItems.concat(payload),
          },
        },
      };
    case actionTypes.REMOVE_CURRENT_DRAFT:
      return {
        ...state,
        currentDraft: {},
      };
    default:
      return state;
  }
};
